import { getCurrentAccount } from "@mirage/service-auth";
import * as primitives from "@mirage/service-typeahead-search/service/primitives";
import { CacheKey } from "@mirage/service-typeahead-search/service/typeahead-cache";
import {
  SourceId,
  typeahead,
} from "@mirage/service-typeahead-search/service/types";
import * as wrappers from "@mirage/service-typeahead-search/service/utils/wrappers";
import * as rx from "rxjs";
import * as op from "rxjs/operators";

import type { PeopleRecommendation } from "@mirage/shared/search/people-recommendations";
import * as sourceScore from "../scoring/source-score";
import { getResultSection } from "../utils/section-mapper";

export const raw: typeahead.TaggedSearch = (query, mode, { cache, config }) => {
  const sectionId = getResultSection(
    typeahead.ResultType.MyProfileSuggestion,
    mode,
    query,
    config,
  );

  return rx.defer(() => {
    const peopleRecommendations = cache.all(
      CacheKey.PeopleRecommendations,
    ) as PeopleRecommendation[];

    return rx.from(getCurrentAccount()).pipe(
      op.map((currentAccount) => {
        const accountId = currentAccount?.account_id;
        if (!accountId) {
          return null;
        }

        const myProfile = peopleRecommendations.find(
          (person) => person.accountId === accountId,
        );

        if (myProfile === undefined) {
          return null;
        }

        const taggedResult = primitives.myProfileSuggestion(
          myProfile.uuid,
          myProfile,
          { sectionId },
        );
        const scoredResult = sourceScore.score(query, config)(taggedResult);
        return scoredResult;
      }),
      op.filter((result) => result !== null),
    );
  });
};

export const search = wrappers.wrapped(SourceId.MyProfileSuggestions, raw);
